import { render, staticRenderFns } from "./CollaboratorRevenueShareCancel.vue?vue&type=template&id=662e6adc&scoped=true&"
import script from "./CollaboratorRevenueShareCancel.vue?vue&type=script&lang=js&"
export * from "./CollaboratorRevenueShareCancel.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorRevenueShareCancel.vue?vue&type=style&index=0&id=662e6adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662e6adc",
  null
  
)

export default component.exports